var map = {
	"./1sb-alert-blue.svg": 666,
	"./1sb-alert-boutique.svg": 667,
	"./1sb-dropdown-black.svg": 611,
	"./1sb-dropdown.svg": 597,
	"./1sb-five-stars-boutique-star-selected.svg": 876,
	"./1sb-five-stars-boutique-star-unselected.svg": 877,
	"./1sb-five-stars-orange-star-selected-boutique.svg": 706,
	"./1sb-five-stars-orange-star-selected.svg": 617,
	"./1sb-five-stars-orange-star-unselected-boutique.svg": 707,
	"./1sb-five-stars-orange-star-unselected.svg": 618,
	"./1sb-loader-icon.svg": 737,
	"./1sb-selected-star.svg": 728,
	"./1sb-tag-icon.svg": 603,
	"./1sb-unselected-star.svg": 729,
	"./1sb_100_night_img.svg": 708,
	"./1sb_Serta_sheep_img.svg": 709,
	"./1sb_Serta_sheep_img_mob.svg": 710,
	"./1sb_cloud_img.svg": 711,
	"./1sb_customer_review_icon.svg": 878,
	"./1sb_mini_logo_boutique.svg": 879,
	"./1sb_mini_logo_white.svg": 656,
	"./1sb_serta_with_sheep_logo_desk_v3.svg": 754,
	"./1sb_serta_with_sheep_logo_mob.svg": 755,
	"./1sb_serta_with_sheep_logo_mob_v1.svg": 756,
	"./BoutiquePopupLogo.svg": 757,
	"./BoutiquePopupLogoMobile.svg": 758,
	"./Mail_80x80.svg": 676,
	"./Mail_boutique_80x80.svg": 677,
	"./animation/icon-sb-buy-as-a-set-and-save-48x48.svg": 880,
	"./animation/icon-sb-shop-the-collection-48x48.svg": 881,
	"./animation/keen-slider-loader.svg": 668,
	"./back_arrow_v1.svg": 738,
	"./black_f_tag_d.svg": 882,
	"./black_friday_deal_text_d.svg": 883,
	"./black_friday_deal_text_d_plp.svg": 884,
	"./black_friday_deal_text_d_v1.svg": 885,
	"./black_friday_deal_text_m.svg": 886,
	"./black_friday_deal_text_m_plp.svg": 887,
	"./black_friday_deal_text_mob_v2.svg": 888,
	"./black_friday_deal_text_plp_d.svg": 889,
	"./black_friday_deal_text_v1.svg": 890,
	"./black_friday_deal_text_v2.svg": 891,
	"./buildyourown_desktop.svg": 892,
	"./buildyourown_mob.svg": 893,
	"./buildyourown_mob_v2.svg": 678,
	"./buildyourown_v2.svg": 894,
	"./buildyourown_v3.svg": 895,
	"./buildyourown_v5.svg": 679,
	"./checkbox_hover-black.svg": 896,
	"./checkbox_hover-gray-bg.svg": 739,
	"./checkbox_hover-gray-border.svg": 897,
	"./checkbox_hover.svg": 898,
	"./checkmark_green_v1.svg": 899,
	"./cms/icon-sb-checkmark-blue-color.svg": 759,
	"./cms/icon-sb-checkmark-white-color-16.svg": 760,
	"./cms/icon-sb-close-24.svg": 761,
	"./cms/icon-sb-link-arrow-red-color-16.svg": 126,
	"./cms/icon-sb-play-blue-color.svg": 900,
	"./coupon_text_desktop.svg": 901,
	"./dropdown-black.svg": 192,
	"./dropdown.svg": 294,
	"./dropdown_black.svg": 482,
	"./errorPage.svg": 473,
	"./helpCenter/Info.svg": 730,
	"./helpCenter/affirm_logo_color-v1.svg": 902,
	"./helpCenter/call.svg": 903,
	"./helpCenter/call_us_48x48.svg": 762,
	"./helpCenter/cash.svg": 904,
	"./helpCenter/check.svg": 905,
	"./helpCenter/credit_card_80x80.svg": 906,
	"./helpCenter/credit_cards.svg": 907,
	"./helpCenter/helpcenter_bg_v1.svg": 908,
	"./helpCenter/icon-sb-account.svg": 909,
	"./helpCenter/icon-sb-call-blue-color-48-v2.svg": 910,
	"./helpCenter/icon-sb-checkmark-green-color-24.svg": 731,
	"./helpCenter/icon-sb-credit-card-color-64x48.svg": 911,
	"./helpCenter/icon-sb-help-center-48x48.svg": 763,
	"./helpCenter/icon-sb-in-home-drop-off-icon-100x67-v1.svg": 912,
	"./helpCenter/icon-sb-in-home-drop-off-icon-160x120-v1.svg": 913,
	"./helpCenter/icon-sb-note-64x48.svg": 914,
	"./helpCenter/icon-sb-outside-drop-off-icon-100x67-v1.svg": 915,
	"./helpCenter/icon-sb-outside-drop-off-icon-160x120-v1.svg": 916,
	"./helpCenter/icon-sb-play.svg": 740,
	"./helpCenter/icon-sb-price-drop-tag-illustration-200x160.svg": 917,
	"./helpCenter/icon-sb-pwgd-blue-color-64x48.svg": 918,
	"./helpCenter/icon-sb-room-of-choice-icon-100x67-v1.svg": 919,
	"./helpCenter/icon-sb-room-of-choice-icon-160x120-v1.svg": 920,
	"./helpCenter/icon-sb-shipping-truck-illustration-200x160.svg": 921,
	"./helpCenter/icon-sb-tip-illustration-128x128.svg": 741,
	"./helpCenter/icon-sb-truck-blue-color-64x48.svg": 922,
	"./helpCenter/icon-sb-unbox-illustration-200x160-v2.svg": 923,
	"./helpCenter/icon-sb-unbox-illustration-200x160.svg": 924,
	"./helpCenter/icon-sb-white-glove-delivery-icon-100x67-v1.svg": 925,
	"./helpCenter/icon-sb-white-glove-delivery-icon-160x120-v1.svg": 926,
	"./helpCenter/katapult.svg": 927,
	"./helpCenter/mail.svg": 764,
	"./helpCenter/paypal.svg": 928,
	"./helpCenter/store_credit.svg": 929,
	"./helpCenter/website.svg": 930,
	"./high_alert_v1.svg": 931,
	"./icon-best-value.svg": 619,
	"./icon-compare.svg": 932,
	"./icon-great-choice.svg": 620,
	"./icon-sb-1sb_Mini_logo-16x16.svg": 657,
	"./icon-sb-1sb_Mini_logo-boutique-16x16.svg": 658,
	"./icon-sb-Info-blue-color-16.svg": 613,
	"./icon-sb-Info-boutique-16.svg": 631,
	"./icon-sb-alert-red.svg": 933,
	"./icon-sb-black-friday-tag.svg": 934,
	"./icon-sb-brand-icon-v1.svg": 935,
	"./icon-sb-build-own-sectional-48x48.svg": 936,
	"./icon-sb-buy-as-a-set-and-save-48x48.svg": 680,
	"./icon-sb-buy-as-a-set-and-save-boutique-48x48.svg": 681,
	"./icon-sb-buy-now-160x106.svg": 659,
	"./icon-sb-buy-now-desktop.svg": 937,
	"./icon-sb-buy-now-mob.svg": 938,
	"./icon-sb-buy-now-tablet.svg": 939,
	"./icon-sb-buy-set-illustration-343x129.svg": 940,
	"./icon-sb-call-us-blue-color-48.svg": 660,
	"./icon-sb-call-us-boutique-color-48.svg": 661,
	"./icon-sb-carousel-arrow-right-black.svg": 682,
	"./icon-sb-carousel-arrow-right.svg": 650,
	"./icon-sb-checklist-illustration.svg": 742,
	"./icon-sb-checkmark-white-color-16.svg": 588,
	"./icon-sb-chevron-down-white-color.svg": 683,
	"./icon-sb-chevron-left-black-color-24.svg": 743,
	"./icon-sb-chevron-left-blue-color-24.svg": 744,
	"./icon-sb-chevron-left-cyan-color-24.svg": 745,
	"./icon-sb-chevron-left-gray-color-24.svg": 746,
	"./icon-sb-chevron-up-white-color.svg": 684,
	"./icon-sb-clock-orange-24x24.svg": 685,
	"./icon-sb-clock-orange-boutique-24x24.svg": 686,
	"./icon-sb-close-24.svg": 941,
	"./icon-sb-close-24_blue.svg": 765,
	"./icon-sb-coupon-color-48x48.svg": 687,
	"./icon-sb-coupon-color-48x48_v1.svg": 942,
	"./icon-sb-coupon-color-boutique-48x48.svg": 688,
	"./icon-sb-coupon-color-boutique-white-24x24.svg": 598,
	"./icon-sb-coupon-color-white-24x24.svg": 599,
	"./icon-sb-customize-this-set-48.svg": 632,
	"./icon-sb-customize-this-set-boutique-48x48.svg": 633,
	"./icon-sb-cyber-monday-tag.svg": 943,
	"./icon-sb-cyber-monday-tag_blue_v1.svg": 944,
	"./icon-sb-down-arrow-black.svg": 669,
	"./icon-sb-dropdown-arrow-10x8.svg": 766,
	"./icon-sb-dropdown-arrow-20.svg": 600,
	"./icon-sb-dropdown-arrow-34.svg": 653,
	"./icon-sb-dropdown-arrow-black-20.svg": 601,
	"./icon-sb-dropdown-arrow-black-34.svg": 654,
	"./icon-sb-dropdown-arrow1-black-20.svg": 945,
	"./icon-sb-dropdown-white-10.svg": 712,
	"./icon-sb-forward-arrow.svg": 651,
	"./icon-sb-forward-arrow_boutique.svg": 652,
	"./icon-sb-hand-truck-blue-color-48.svg": 767,
	"./icon-sb-hand-truck-boutique-48.svg": 946,
	"./icon-sb-high-alert-color-80.svg": 670,
	"./icon-sb-katapult-logo.svg": 689,
	"./icon-sb-labor-day-bg.svg": 671,
	"./icon-sb-link-arrow-botique-color-16.svg": 634,
	"./icon-sb-link-arrow-red-color-16.svg": 596,
	"./icon-sb-link-bottom-arrow-red-color-16-v1.svg": 690,
	"./icon-sb-link-bottom-arrow-red-color-boutique-16x16.svg": 635,
	"./icon-sb-link-forward-arrow-red-color-16.svg": 691,
	"./icon-sb-logo-illustration.svg": 732,
	"./icon-sb-low-alert-orange-48x48.svg": 692,
	"./icon-sb-low-alert-orange-boutique-48x48.svg": 693,
	"./icon-sb-mattress-extra-firm-40_v1.svg": 636,
	"./icon-sb-mattress-extra-firm-boutique-40.svg": 637,
	"./icon-sb-mattress-firm-color-36.svg": 638,
	"./icon-sb-mattress-firm-color-boutique-36.svg": 639,
	"./icon-sb-mattress-medium-40.svg": 640,
	"./icon-sb-mattress-medium-boutique-40.svg": 641,
	"./icon-sb-mattress-next-arrow.svg": 713,
	"./icon-sb-mattress-next-arrow_boutique.svg": 714,
	"./icon-sb-mattress-plus-color-36.svg": 642,
	"./icon-sb-mattress-plus-color-boutique-36.svg": 643,
	"./icon-sb-mattress-prev-arrow.svg": 715,
	"./icon-sb-mattress-prev-arrow_boutique.svg": 716,
	"./icon-sb-mattress-returns-48.svg": 947,
	"./icon-sb-mattress-returns-boutique-48.svg": 948,
	"./icon-sb-mattress-ultra-plus-color-36.svg": 644,
	"./icon-sb-mattress-ultra-plus-color-boutique-36.svg": 645,
	"./icon-sb-minus.svg": 694,
	"./icon-sb-other-sectional-layouts-boutique_dektop.svg": 695,
	"./icon-sb-other-sectional-layouts-boutique_dektop_v1.svg": 696,
	"./icon-sb-other-sectional-layouts.svg": 697,
	"./icon-sb-other-sectional-layouts_v1.svg": 698,
	"./icon-sb-ottoman-recliner-48x48.svg": 646,
	"./icon-sb-ottoman-recliner.svg": 647,
	"./icon-sb-plus-12x12.svg": 699,
	"./icon-sb-recent-products-empty.svg": 700,
	"./icon-sb-returns-48.svg": 949,
	"./icon-sb-returns-boutique-48.svg": 950,
	"./icon-sb-shipping-truck-illustration.svg": 747,
	"./icon-sb-shop-more-160x106.svg": 662,
	"./icon-sb-shop-more-desktop.svg": 951,
	"./icon-sb-shop-more-mob.svg": 952,
	"./icon-sb-shop-more-tablet.svg": 953,
	"./icon-sb-shop-similar.svg": 612,
	"./icon-sb-shop-the-collection-48x48.svg": 701,
	"./icon-sb-shop-the-collection-boutique-48x48.svg": 702,
	"./icon-sb-star-filled.svg": 672,
	"./icon-sb-trash-16x16.svg": 703,
	"./icon-sb-trend.svg": 717,
	"./icon-sb-unbox-illustration.svg": 748,
	"./icon-sb-up-arrow-black.svg": 673,
	"./icon-sb-white-glove-160x106.svg": 663,
	"./icon-sb-white-glove-desktop.svg": 954,
	"./icon-sb-white-glove-mob.svg": 955,
	"./icon-sb-white-glove-tablet.svg": 956,
	"./icon-true-luxury.svg": 621,
	"./icon_sb_affirm_48x48.svg": 957,
	"./icon_sb_hand_truck_48x48.svg": 733,
	"./icon_sb_rating_alt_desktop.svg": 958,
	"./icon_sb_return_16x16.svg": 959,
	"./icon_sb_return_boutique_16x16.svg": 960,
	"./icon_sb_return_boutique_black_14x14_v1.svg": 961,
	"./icon_sb_return_boutique_black_14x14_v2.svg": 962,
	"./icon_sb_return_boutique_black_16x16.svg": 963,
	"./icon_sb_return_boutique_black_16x16_v1.svg": 718,
	"./icon_sb_shipping_16x16.svg": 964,
	"./icon_sb_shipping_16x16_v2.svg": 768,
	"./icon_sb_shipping_18x13.svg": 965,
	"./icon_sb_shipping_18x13_v1.svg": 769,
	"./icon_sb_shipping_boutique_16x16.svg": 966,
	"./icon_sb_star_16.svg": 967,
	"./icon_sb_white_glove_16x16.svg": 968,
	"./icon_sb_white_glove_boutique_16x16.svg": 969,
	"./icon_sb_white_glove_diamond_16x16.svg": 970,
	"./icon_sb_white_glove_diamond_16x16_v1.svg": 971,
	"./icon_sb_white_glove_diamond_16x16_v2.svg": 972,
	"./icons/animation/1sb-loader_icon.svg": 664,
	"./icons/credit-card/icon-sb-cvv-32x32.svg": 704,
	"./illustrationicon-sb-ottoman-recliner-boutique-48x48.svg": 648,
	"./illustrationicon-sb-ottoman-recliner-boutique.svg": 649,
	"./images/Katapult_Logo.svg": 719,
	"./images/affirm-financing/affirm_payment_plan_img.svg": 749,
	"./images/affirm-financing/affirm_payment_plan_mobile.svg": 720,
	"./images/affirm-financing/katapukt_screen.svg": 750,
	"./images/affirm-financing/katapukt_screen_mobile.svg": 721,
	"./images/affirm_logo.svg": 751,
	"./images/affirm_logo_color.svg": 655,
	"./images/guardian_full_img.svg": 770,
	"./logo-238x80.svg": 335,
	"./logo-gold-167x57.svg": 973,
	"./logo-white-167x57.svg": 734,
	"./logo.svg": 974,
	"./mattress-none-boutique.svg": 975,
	"./mattress-none.svg": 976,
	"./one_img_orange_tag.svg": 977,
	"./one_img_orange_tag_desktop_v1.svg": 978,
	"./onepage/affirm.svg": 622,
	"./onepage/american-express.svg": 623,
	"./onepage/discover.svg": 624,
	"./onepage/icon-sb-delete-address-illustration-200x200.svg": 604,
	"./onepage/katapult_payment_loan.svg": 625,
	"./onepage/mastercard.svg": 626,
	"./onepage/paypal_express.svg": 627,
	"./onepage/place-order-affirm.svg": 605,
	"./onepage/place-order-katapult.svg": 606,
	"./onepage/place-order-paypal.svg": 607,
	"./onepage/visa.svg": 628,
	"./placeholder-animation.svg": 591,
	"./president_tag_bg.svg": 979,
	"./reviews/1sb-dropdown.svg": 722,
	"./reviews/1sb_five_stars_selected_ekomi_d.svg": 980,
	"./reviews/1sb_five_stars_selected_google_d.svg": 981,
	"./reviews/1sb_five_stars_selected_reseller_d.svg": 982,
	"./reviews/1sb_five_stars_selected_reviews_d.svg": 983,
	"./reviews/1sb_five_stars_selected_shopper_d.svg": 984,
	"./reviews/1sb_five_stars_selected_sidejabber_d.svg": 985,
	"./reviews/1sb_five_stars_selected_trustpilot_d.svg": 986,
	"./reviews/1sb_five_stars_unselected_ekomi_d.svg": 987,
	"./reviews/1sb_five_stars_unselected_google_d.svg": 988,
	"./reviews/1sb_five_stars_unselected_reseller_d.svg": 989,
	"./reviews/1sb_five_stars_unselected_reviews_d.svg": 990,
	"./reviews/1sb_five_stars_unselected_shopper_d.svg": 991,
	"./reviews/1sb_five_stars_unselected_sidejabber_d.svg": 992,
	"./reviews/1sb_five_stars_unselected_trustpilot_d.svg": 993,
	"./reviews/icon-sb-checkmark-white-color-16.svg": 771,
	"./reviews/icon_sb_checkmark_green.svg": 665,
	"./reviews/icon_sb_rating_alt_desktop_v1.svg": 723,
	"./reviews/icon_sb_rating_alt_desktop_v2.svg": 724,
	"./reviews/icon_sb_rating_alt_mob_v1.svg": 725,
	"./reviews/icon_sb_select_star_ekomi_t.svg": 994,
	"./reviews/icon_sb_select_star_google_t.svg": 995,
	"./reviews/icon_sb_select_star_reseller_t.svg": 996,
	"./reviews/icon_sb_select_star_reviews_i_t.svg": 997,
	"./reviews/icon_sb_select_star_shopper_t.svg": 998,
	"./reviews/icon_sb_select_star_sitejabber_t.svg": 999,
	"./reviews/icon_sb_select_star_trustpilot_t.svg": 1000,
	"./reviews/icon_sb_unselect_star_ekomi_t.svg": 1001,
	"./reviews/icon_sb_unselect_star_google_t.svg": 1002,
	"./reviews/icon_sb_unselect_star_reseller_t.svg": 1003,
	"./reviews/icon_sb_unselect_star_reviews_i_t.svg": 1004,
	"./reviews/icon_sb_unselect_star_shopper_t.svg": 1005,
	"./reviews/icon_sb_unselect_star_sitejabber_t.svg": 1006,
	"./reviews/icon_sb_unselect_star_trustpilot_t.svg": 1007,
	"./reviews/review_banner_d.svg": 726,
	"./reviews/review_banner_m.svg": 735,
	"./reviews/review_banner_t.svg": 1008,
	"./sb_ashley_tag.svg": 1009,
	"./selected-checkbox.svg": 477,
	"./selected-checkbox_black-1.svg": 752,
	"./selected-checkbox_black.svg": 1010,
	"./selected-checkbox_boutique.svg": 674,
	"./selected-colorGenBlack.svg": 772,
	"./selected-colorGenWhite.svg": 610,
	"./selected-disabled-checkbox.svg": 435,
	"./selected-radio_black.svg": 614,
	"./selected-radio_boutique.svg": 615,
	"./selected.svg": 475,
	"./sofa-img-v1.svg": 773,
	"./star_icon_16.svg": 1011,
	"./table-sort-up.svg": 478,
	"./tag/1sb_mini_logo_white.svg": 629,
	"./tag/icon-sb-1sb_Mini_logo-16x16.svg": 630,
	"./tag/icon-sb-labor-day-bg.svg": 608,
	"./tag/icon-sb-star-filled.svg": 609,
	"./testimonials/1sb-dropdown.svg": 774,
	"./testimonials/1sb-five-stars-orange-five_new_v1.svg": 1012,
	"./testimonials/1sb-five-stars-orange-new_mob.svg": 1013,
	"./testimonials/icon-sb-chevron-down-blue-color.svg": 775,
	"./unselected-checkbox.svg": 448,
	"./unselected-checkbox_gray.svg": 1014,
	"./unselected-disabled-checkbox.svg": 436,
	"./unselected-radio_black.svg": 616,
	"./unselected.svg": 476,
	"./widget-91x73.svg": 336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;